'use client';

import { useCallback, useState, type ReactNode } from 'react';

import { SiteHeader } from '@/components/layouts/site-header';
import { FooterDescription } from '@/features/footer/components/footer-description';

interface UserLayoutShellProps {
  children: ReactNode;
}

export function UserLayoutShell({ children }: UserLayoutShellProps) {
  const [update, setUpdate] = useState(0);

  const bumpUpdate = useCallback(() => {
    setUpdate((value) => value + 1);
  }, []);

  return (
    <div data-site="user" className="flex min-h-full flex-col bg-white font-sans">
      <SiteHeader setUpdate={bumpUpdate} />
      <main className="flex-1">{children}</main>
      <FooterDescription key={update} />
    </div>
  );
}
